import './style.scss'; 
 
import React, { FC } from 'react';
import { motion } from "framer-motion";
 
const Footer: FC = () => {
    const currentYear = new Date().getFullYear();
    return (
        <motion.footer
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="w-full bg-gray-900 text-white py-6 mt-10 shadow-inner"
        >
            <div className="container mx-auto px-4 text-center">
                <p className="text-sm md:text-base tracking-wide">
                    © {currentYear} <a href="/" className="font-semibold text-primary">ID PROTECT</a> — tous droits réservés
                </p>
            </div>
        </motion.footer>
    );
} 
 
export default Footer; 
